import useAuth from './useAuth';

export type IFeatureFlags =
	| 'REMINDERS'
	| 'PARTICIPANTS'
	| 'CALENDARS'
	| 'GROUPS'
	| 'PAYMENTS'
	| 'WORKFLOWS'
	| 'PRICING_POLICY';

/**
 * Enable every experimental feature on dev mode.
 */
export default function useFeature(featureFlagName: IFeatureFlags) {
	const auth = useAuth();
	const currentUserEmail = auth.getCurrentUser().email;

	// TimeTime users can see everything
	if (currentUserEmail.includes('timetime')) {
		return true;
	}

	if (featureFlagName === 'REMINDERS') {
		return currentUserEmail.includes('mairelesabogados.com');
	}

	if (featureFlagName === 'GROUPS') {
		return currentUserEmail.toLowerCase().includes('trackingplan');
	}

	if (featureFlagName === 'PARTICIPANTS') {
		return false;
	}

	if (featureFlagName === 'CALENDARS') {
		return currentUserEmail.toLowerCase().includes('rapidand');
	}

	if (featureFlagName === 'PRICING_POLICY') {
		return currentUserEmail.toLowerCase().includes('cluber');
	}

	return false;
}
